import { ErikExceptionHome } from './ErikExceptionHome';

// Erik Exception Home v1: wraps the existing Erik escalation queue with
// system-trust, misroute, and high-risk review context.
export function ErikQueue(): JSX.Element {
  return <ErikExceptionHome />;
}
